export default "__VITE_ASSET__DcaSfhly__"